export const LanguageData = [
  { name: "Afghanistan(Pashto)", code: "ps" },
  { name: "Albania(Albanian)", code: "sq" },
  { name: "Algeria(Arabic)", code: "ar" },
  { name: "Argentina(Spanish)", code: "es" },
  { name: "Armenia(Armenian)", code: "hy" },
  { name: "Australia(English)", code: "en" },
  { name: "Austria(German)", code: "de" },
  { name: "Azerbaijan(Azerbaijani (Cyrillic))", code: "az" },
  { name: "Azerbaijan(Azerbaijani (Latin))", code: "az" },
  { name: "Bahrain(Arabic)", code: "ar" },
  { name: "Bangladesh(Bangla)", code: "bn" },
  { name: "Belarus(Belarusian)", code: "be" },
  { name: "Belgium(Dutch)", code: "nl" },
  { name: "Belgium(French)", code: "fr" },
  { name: "Belize(English)", code: "en" },
  { name: "Bolivia(Spanish)", code: "es" },
  { name: "Bosnia &amp; Herzegovina(Bosnian (Cyrillic))", code: "bs" },
  { name: "Bosnia &amp; Herzegovina(Bosnian (Latin))", code: "bs" },
  { name: "Bosnia &amp; Herzegovina(Croatian)", code: "hr" },
  { name: "Bosnia &amp; Herzegovina(Serbian (Cyrillic))", code: "sr" },
  { name: "Bosnia &amp; Herzegovina(Serbian (Latin))", code: "sr" },
  { name: "Botswana(Tswana)", code: "tn" },
  { name: "Brazil(Portuguese)", code: "pt" },
  { name: "Brunei(Malay)", code: "ms" },
  { name: "Bulgaria(Bulgarian)", code: "bg" },
  { name: "Cambodia(Khmer)", code: "km" },
  { name: "Cameroon(French)", code: "fr" },
  { name: "Canada(English)", code: "en" },
  { name: "Canada(French)", code: "fr" },
  { name: "Chile(Spanish)", code: "es" },
  { name: "China(Chinese)", code: "zh" },
  { name: "China(Sichuan Yi)", code: "ii" },
  { name: "China(Tibetan)", code: "bo" },
  { name: "China(Uyghur)", code: "ug" },
  { name: "Colombia(Spanish)", code: "es" },
  { name: "Congo - Kinshasa(French)", code: "fr" },
  { name: "Costa Rica(Spanish)", code: "es" },
  { name: "C?te d?Ivoire(French)", code: "fr" },
  { name: "Croatia(Croatian)", code: "hr" },
  { name: "Cuba(Spanish)", code: "es" },
  { name: "Czech Republic(Czech)", code: "cs" },
  { name: "Denmark(Danish)", code: "da" },
  { name: "Dominican Republic(Spanish)", code: "es" },
  { name: "Ecuador(Spanish)", code: "es" },
  { name: "Egypt(Arabic)", code: "ar" },
  { name: "El Salvador(Spanish)", code: "es" },
  { name: "Eritrea(Tigrinya)", code: "ti" },
  { name: "Estonia(Estonian)", code: "et" },
  { name: "Ethiopia(Amharic)", code: "am" },
  { name: "Ethiopia(Oromo)", code: "om" },
  { name: "Ethiopia(Tigrinya)", code: "ti" },
  { name: "Faroe Islands(Faroese)", code: "fo" },
  { name: "Finland(Finnish)", code: "fi" },
  { name: "Finland(Inari Sami)", code: "smn" },
  { name: "Finland(Northern Sami)", code: "se" },
  { name: "Finland(Swedish)", code: "sv" },
  { name: "France(Breton)", code: "br" },
  { name: "France(French)", code: "fr" },
  { name: "France(Swiss German)", code: "gsw" },
  { name: "Georgia(Georgian)", code: "ka" },
  { name: "Germany(German)", code: "de" },

  { name: "Greece(Greek)", code: "el" },
  { name: "Greenland(Kalaallisut)", code: "kl" },
  { name: "Guatemala(Spanish)", code: "es" },
  { name: "Haiti(French)", code: "fr" },
  { name: "Honduras(Spanish)", code: "es" },
  { name: "Hong Kong SAR China(Chinese (Traditional))", code: "zh" },
  { name: "Hong Kong SAR China(English)", code: "en" },
  { name: "Hungary(Hungarian)", code: "hu" },
  { name: "Iceland(Icelandic)", code: "is" },
  { name: "India(Assamese)", code: "as" },
  { name: "India(Bangla)", code: "bn" },
  { name: "India(English)", code: "en" },
  { name: "India(Gujarati)", code: "gu" },
  { name: "India(Hindi)", code: "hi" },
  { name: "India(Kannada)", code: "kn" },
  { name: "India(Konkani)", code: "kok" },
  { name: "India(Malayalam)", code: "ml" },
  { name: "India(Marathi)", code: "mr" },
  { name: "India(Nepali)", code: "ne" },
  { name: "India(Odia)", code: "or" },
  { name: "India(Tamil)", code: "ta" },
  { name: "India(Telugu)", code: "te" },
  { name: "India(Urdu)", code: "ur" },
  { name: "Indonesia(Indonesian)", code: "id" },
  { name: "Iran(Persian)", code: "fa" },
  { name: "Iraq(Arabic)", code: "ar" },
  { name: "Ireland(English)", code: "en" },
  { name: "Ireland(Irish)", code: "ga" },
  { name: "Israel(Hebrew)", code: "he" },
  { name: "Italy(Italian)", code: "it" },
  { name: "Jamaica(English)", code: "en" },
  { name: "Japan(Japanese)", code: "ja" },
  { name: "Jordan(Arabic)", code: "ar" },
  { name: "Kazakhstan(Kazakh)", code: "kk" },
  { name: "Kenya(Swahili)", code: "sw" },
  { name: "Kuwait(Arabic)", code: "ar" },
  { name: "Kyrgyzstan(Kyrgyz)", code: "ky" },
  { name: "Laos(Lao)", code: "lo" },
  { name: "Latvia(Latvian)", code: "lv" },
  { name: "Lebanon(Arabic)", code: "ar" },
  { name: "Libya(Arabic)", code: "ar" },
  { name: "Liechtenstein(German)", code: "de" },
  { name: "Lithuania(Lithuanian)", code: "lt" },
  { name: "Luxembourg(French)", code: "fr" },
  { name: "Luxembourg(German)", code: "de" },
  { name: "Luxembourg(Luxembourgish)", code: "lb" },
  { name: "Macau SAR China(Chinese (Traditional))", code: "zh" },
  { name: "Macedonia(Macedonian)", code: "mk" },
  { name: "Malaysia(English)", code: "en" },
  { name: "Malaysia(Malay)", code: "ms" },
  { name: "Mali(French)", code: "fr" },
  { name: "Malta(Maltese)", code: "mt" },
  { name: "Mexico(Spanish)", code: "es" },
  { name: "Moldova(Romanian)", code: "ro" },
  { name: "Moldova(Russian)", code: "ru" },
  { name: "Monaco(French)", code: "fr" },
  { name: "Mongolia(Mongolian (Cyrillic))", code: "mn" },
  { name: "Montenegro(Serbian (Cyrillic))", code: "sr" },
  { name: "Montenegro(Serbian (Latin))", code: "sr" },
  { name: "Morocco(Arabic)", code: "ar" },
  { name: "Morocco(French)", code: "fr" },
  { name: "Myanmar (Burma)(Burmese)", code: "my" },
  { name: "Nepal(Nepali)", code: "ne" },
  { name: "Netherlands(Dutch)", code: "nl" },
  { name: "Netherlands(Western Frisian)", code: "fy" },
  { name: "New Zealand(English)", code: "en" },
  { name: "Nicaragua(Spanish)", code: "es" },
  { name: "Nigeria(Hausa (Latin))", code: "ha" },
  { name: "Nigeria(Igbo)", code: "ig" },
  { name: "Nigeria(Yoruba)", code: "yo" },
  { name: "Norway(Northern Sami)", code: "se" },
  { name: "Norway(Norwegian Bokm?l)", code: "nb" },
  { name: "Norway(Norwegian Nynorsk)", code: "nn" },
  { name: "Oman(Arabic)", code: "ar" },
  { name: "Pakistan(Punjabi (Arabic))", code: "pa" },
  { name: "Pakistan(Urdu)", code: "ur" },
  { name: "Panama(Spanish)", code: "es" },
  { name: "Paraguay(Spanish)", code: "es" },
  { name: "Peru(Spanish)", code: "es" },
  { name: "Philippines(English)", code: "en" },
  { name: "Philippines(Filipino)", code: "fil" },
  { name: "Poland(Polish)", code: "pl" },
  { name: "Portugal(Portuguese)", code: "pt" },
  { name: "Puerto Rico(Spanish)", code: "es" },
  { name: "Qatar(Arabic)", code: "ar" },
  { name: "R?union(French)", code: "fr" },
  { name: "Romania(Romanian)", code: "ro" },
  { name: "Russia(Russian)", code: "ru" },

  { name: "Russia(Tatar)", code: "tt" },
  { name: "Rwanda(Kinyarwanda)", code: "rw" },
  { name: "Saudi Arabia(Arabic)", code: "ar" },
  { name: "Senegal(French)", code: "fr" },
  { name: "Serbia(Serbian (Cyrillic))", code: "sr" },
  { name: "Serbia(Serbian (Latin))", code: "sr" },

  { name: "Singapore(English)", code: "en" },
  { name: "Slovakia(Slovak)", code: "sk" },
  { name: "Slovenia(Slovenian)", code: "sl" },
  { name: "Somalia(Somali)", code: "so" },
  { name: "South Africa(Afrikaans)", code: "af" },
  { name: "South Africa(English)", code: "en" },
  { name: "South Africa(Northern Sotho)", code: "nso" },
  { name: "South Africa(Southern Sotho)", code: "st" },
  { name: "South Africa(Tsonga)", code: "ts" },
  { name: "South Africa(Tswana)", code: "tn" },
  { name: "South Africa(Xhosa)", code: "xh" },
  { name: "South Africa(Zulu)", code: "zu" },
  { name: "South Korea(Korean)", code: "ko" },
  { name: "Spain(Basque)", code: "eu" },
  { name: "Spain(Catalan (Spain))", code: "ca" },
  { name: "Spain(Catalan)", code: "ca" },
  { name: "Spain(Galician)", code: "gl" },
  { name: "Spain(Spanish)", code: "es" },
  { name: "Sri Lanka(Sinhala)", code: "si" },
  { name: "Sri Lanka(Tamil)", code: "ta" },
  { name: "Sweden(Northern Sami)", code: "se" },
  { name: "Sweden(Swedish)", code: "sv" },
  { name: "Switzerland(French)", code: "fr" },
  { name: "Switzerland(German)", code: "de" },
  { name: "Switzerland(Italian)", code: "it" },
  { name: "Switzerland(Romansh)", code: "rm" },
  { name: "Syria(Arabic)", code: "ar" },
  { name: "Taiwan(Chinese (Traditional) Legacy)", code: "zh" },
  { name: "Tajikistan(Tajik (Cyrillic))", code: "tg" },
  { name: "Thailand(Thai)", code: "th" },
  { name: "Trinidad &amp; Tobago(English)", code: "en" },
  { name: "Tunisia(Arabic)", code: "ar" },
  { name: "Turkey(Turkish)", code: "tr" },
  { name: "Turkmenistan(Turkmen)", code: "tk" },
  { name: "Ukraine(Ukrainian)", code: "uk" },
  { name: "United Arab Emirates(Arabic)", code: "ar" },
  { name: "United Kingdom(English)", code: "en" },
  { name: "United Kingdom(Scottish Gaelic)", code: "gd" },
  { name: "United Kingdom(Welsh)", code: "cy" },
  { name: "United States(English)", code: "en" },
  { name: "United States(Hawaiian)", code: "haw" },
  { name: "United States(Spanish)", code: "es" },
  { name: "Uruguay(Spanish)", code: "es" },
  { name: "Uzbekistan(Uzbek (Cyrillic))", code: "uz" },
  { name: "Uzbekistan(Uzbek (Latin))", code: "uz" },
  { name: "Venezuela(Spanish)", code: "es" },
  { name: "Vietnam(Vietnamese)", code: "vi" },
  { name: "Yemen(Arabic)", code: "ar" },
  { name: "Zimbabwe(English)", code: "en" },
];
